
import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleBrandClick = (brand: string) => {
    // Navigate to inventory page with brand parameter
    navigate(`/inventory?brand=${brand}`);
  };

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-purple-900 to-pink-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 店舗情報 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-300">紳士服のミッキー</h3>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-pink-400"></i>
                栃木県足利市相生町1-2
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2 text-pink-400"></i>
                0284-41-8666
              </p>
              <p className="flex items-center">
                <i className="ri-time-line mr-2 text-pink-400"></i>
                AM9時30分 ～ PM7時30分
              </p>
              <p className="flex items-center">
                <i className="ri-calendar-line mr-2 text-pink-400"></i>
                定休日：年中無休
              </p>
              <p className="flex items-center">
                <i className="ri-car-line mr-2 text-pink-400"></i>
                駐車場：6台完備（無料）
              </p>
            </div>
          </div>

          {/* ブランド */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-300">取扱ブランド</h3>
            <ul className="space-y-2 text-gray-300">
              <li 
                className="hover:text-pink-400 transition-colors cursor-pointer"
                onClick={() => handleBrandClick('PANDIESTA')}
                style={{ fontFamily: 'Arial, sans-serif' }}
              >
                PANDIESTA
              </li>
              <li 
                className="hover:text-pink-400 transition-colors cursor-pointer"
                onClick={() => handleBrandClick('SINACOVA')}
                style={{ fontFamily: 'Arial, sans-serif' }}
              >
                SINACOVA
              </li>
              <li 
                className="hover:text-pink-400 transition-colors cursor-pointer"
                onClick={() => handleBrandClick('BARNI VARNO')}
                style={{ fontFamily: 'Arial, sans-serif' }}
              >
                BARNI VARNO
              </li>
            </ul>
          </div>

          {/* ナビゲーション */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-300">サイトマップ</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-pink-400 transition-colors">ホーム</Link></li>
              <li><Link to="/inventory" className="hover:text-pink-400 transition-colors">在庫一覧</Link></li>
              <li><Link to="/store" className="hover:text-pink-400 transition-colors">店舗情報</Link></li>
              <li><Link to="/contact" className="hover:text-pink-400 transition-colors">お問い合わせ</Link></li>
            </ul>
          </div>

          {/* SNS */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-300">フォローする</h3>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/shouyongdazuo/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="https://x.com/sunagamikey" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                <i className="ri-twitter-line text-white"></i>
              </a>
              <a href="https://www.facebook.com/p/%E5%AF%BF%E6%B0%B8%E5%A4%A7%E4%BD%9C-100022295354218/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                <i className="ri-facebook-line text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 紳士服のミッキー. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-pink-400 hover:text-pink-300 ml-2">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
